import React from 'react';
import styles from './ButtonStoreLink.module.css';
import classNames from 'classnames';

interface IButtonStoreLink
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  to: string;
  css?: string;
  store: string;
}

export const ButtonStoreLink: React.FC<IButtonStoreLink> = ({
  children,
  to,
  css,
  store
}) => {
  let style = classNames(styles.btn, styles.container, css);

  const handleClick = () => {
      (window as any).ym(95716497, 'reachGoal', 'DOWNLOAD_APP');
      (window as any).ym(95716497, 'reachGoal', store);
  };

  return (
    <a className={style} href={to} target="_blank" onClick={handleClick}>
      {children}
    </a>
  );
};
